import { useEffect } from "react";
import Lenis from "lenis";
import Header from "@/components/landing/Header";
import SupportSection from "@/components/landing/SupportSection";
import Marquee from "@/components/landing/Marquee";
import Footer from "@/components/landing/Footer";

function App() {
  useEffect(() => {
    document.title = "Dolphin Retail Media - Support and Resources";
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1.05 });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div
      data-testid="landing-page"
      id="top"
      className="min-h-screen bg-[#08080c] text-white antialiased selection:bg-[#e0359e]/30 selection:text-white"
    >
      <Header />
      <main>
        <SupportSection />
        <Marquee />
      </main>
      <Footer />
    </div>
  );
}

export default App;
